import MatchServices from '../xx-vue/services/match'
import Storage from '../xx-vue/utils/storage'
const userInfo = Storage.getStorage('info');
export default {
    namespaced: true,
    state: {
        page: 1,
        limit: 6,
        total: 0,
        matchClass: { name: '推荐' },
        matchList: []
    },
    mutations: {
        getMatchList: (state, payload) => {
            state.matchList = payload
            console.log(state.matchList);
        },
        changePage: (state, payload) => {
            state.page = payload
        },
        changeLimit: (state, payload) => {
            state.limit = payload
        },
        changeClass: (state, payload) => {
            state.matchClass = payload
        },
        changeTotal: (state, payload) => {
            state.total = payload
        }
    },
    actions: {
        getMatchList: async ({ commit, state }) => {
            let params = { page: state.page, limit: state.limit };
            switch (state.matchClass.name) {
                case '推荐':
                    params = { ...params, is_recommend: 1 };
                    break;
                case '最新':
                    break;
                case '我的参赛':
                    params = { ...params, is_mine_join: 1 };
                    break;
                case '我的评审':
                    params = { ...params, expert_id: userInfo.expert_info.id };
                    break;
                default:
                    params = { ...params, art_id: state.matchClass.id }
            }
            let result = await MatchServices.getMatchAsync(params);
            commit('changeTotal', result.data.total)
            const data = result.data.list.map(v => {
                const date_end_num = new Date(v.date_end).getTime()//开始时间戳
                const leftTime_num = (date_end_num - v.contest_time.now_time * 1000) / 1000;//剩余时间
                let leftTime = ''
                if (leftTime_num > 0) {
                    const days = parseInt(leftTime_num / (24 * 60 * 60));//计算整数天数

                    const afterDay = leftTime_num - days * 24 * 60 * 60;//取得算出天数后剩余的秒数

                    const hours = parseInt(afterDay / (60 * 60));//计算整数小时数

                    const afterHour = leftTime_num - days * 24 * 60 * 60 - hours * 60 * 60;//取得算出小时数后剩余的秒数

                    const minutes = parseInt(afterHour / 60);//计算整数分

                    const seconds = parseInt(leftTime_num - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60)
                    if (days !== 0) {
                        leftTime += days + '天'
                    }
                    if (hours !== 0) {
                        leftTime += hours + '小时'
                    }
                    if (minutes !== 0) {
                        leftTime += minutes + '分'
                    }
                    if (seconds !== 0) {
                        leftTime += seconds + '秒'
                    }
                }
                if (leftTime !== '') {
                    return { ...v, date_start_show: v.date_start.split(' ')[0].replace(/-/g, "."), date_end_show: v.date_end.split(' ')[0].replace(/-/g, "."), leftTime: leftTime }
                } else {
                    return { ...v, date_start_show: v.date_start.split(' ')[0].replace(/-/g, "."), date_end_show: v.date_end.split(' ')[0].replace(/-/g, ".") }
                }
            })
            commit('getMatchList', data)
        }
    },
    getters: {
        pages: state => {
            return Math.ceil(state.total / state.limit);
        }
    }
}